import React from 'react';
import { AppContainer } from './App.styled';

import { HistoricalDatesContainer } from '../pages';

export const App = () => {
  return (
    <AppContainer>
      <HistoricalDatesContainer />
    </AppContainer>
  );
}

